import { Calendar } from "primereact/calendar";
import { useDispatch } from "react-redux";
import { setDate } from "../../stateManagement/reducers/services/weatherStations/WeatherStationsSlice";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import { useGetMeasurementsDateRangeQuery } from "../../api/rtk/weatherStations/slices/weatherStationsApiSlice";
import { useEffect, useState } from "react";

export function DateFilter() {
    const dispatch = useDispatch();
    const date = useAppSelector(state => state.weatherStationsService.date)
    const [minDate, setMinDate] = useState<any>();
    const [maxDate, setMaxDate] = useState<any>(new Date());

    const { data: dateRange } = useGetMeasurementsDateRangeQuery({})

    useEffect(() => {
        if (dateRange) {
            const { firstMeasurementAt, lastMeasurementAt } = dateRange ?? {}
            firstMeasurementAt && setMinDate(new Date(firstMeasurementAt))
            lastMeasurementAt && setMaxDate(new Date(lastMeasurementAt))
        }
    }, [dateRange])

    return (
        <div className="date-filter-div">
            <Calendar
                className="date-filter-calendar"
                value={new Date(date)}
                onChange={(event: any) => dispatch(setDate(event.value.toISOString()))}
                inline
                showOtherMonths={false}
                selectionMode="single"
                minDate={minDate}
                maxDate={maxDate}
            />
        </div>
    )
}
